import styled from "styled-components";
import { Button } from "antd";

export const OrderCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }
`;

export const CardContent = styled.div`
  padding: 16px;
  display: flex;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 12px;
  }
`;

export const OrderInfo = styled.div`
  flex: 1;
  min-width: 0; // Prevents flex item from overflowing
`;

export const OrderHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const CustomerName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const OrderEmail = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 8px 0;
`;

export const ProductName = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: #374151;
  margin: 0 0 8px 0;
`;

export const OrderDetails = styled.div`
  margin-top: 12px;
`;

export const OrderDate = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 4px 0;
`;

export const EstimatedCompletion = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

export const OrderMetrics = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  min-width: 140px;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    min-width: unset;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const MetricItem = styled.div`
  text-align: right;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AmountValue = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
`;

export const StatusTag = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => {
    switch (props.status) {
      case 'fulfilled':
      case 'completed':
        return '#ecfdf5';
      case 'unfulfilled':
      case 'pending':
        return '#fff1f2';
      case 'in_progress':
      case 'processing':
        return '#eff6ff';
      default:
        return '#f3f4f6';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'fulfilled':
      case 'completed':
        return '#059669';
      case 'unfulfilled':
      case 'pending':
        return '#dc2626';
      case 'in_progress':
      case 'processing':
        return '#2563eb';
      default:
        return '#6b7280';
    }
  }};
`;

export const ActionButton = styled(Button)`
  height: 48px;

  @media (max-width: 768px) {
    width: 100%;
  }

  &.ant-btn-primary {
    background: #2563eb;
    border-color: #2563eb;
    
    &:hover {
      background: #1d4ed8;
      border-color: #1d4ed8;
    }
  }
`;

export const ModalContent = styled.div`
  font-size: 14px;
  color: #374151;
  white-space: pre-wrap;
`;

export const CustomerNotes = styled.div`
  margin-top: 12px;
  background: #f9fafb;
  padding: 12px;
  border-radius: 6px;
`;

export const NotesLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
`;

export const NotesPreview = styled.div`
  font-size: 14px;
  color: #374151;
  line-height: 1.4;
`;

export const FeaturesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
`;

export const FeatureTag = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => {
    switch (props.type) {
      case 'follows':
        return '#eff6ff';
      case 'likes':
        return '#f0fdf4';
      case 'comments':
        return '#fdf4ff';
      case 'shoutouts':
        return '#fdf2f8';
      case 'custom':
        return '#fff7ed';
      default:
        return '#f3f4f6';
    }
  }};
  color: ${props => {
    switch (props.type) {
      case 'follows':
        return '#2563eb';
      case 'likes':
        return '#16a34a';
      case 'comments':
        return '#9333ea';
      case 'shoutouts':
        return '#db2777';
      case 'custom':
        return '#ea580c';
      default:
        return '#6b7280';
    }
  }};
`;

export const PlatformInfo = styled.div`
  margin: 4px 0;
`;

export const PlatformTag = styled.span`
  font-size: 13px;
  color: #4b5563;
  background: #f3f4f6;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
`;